<div class="flex flex-row justify-end">
	<button
		mat-icon-button
		mat-dialog-close>
		<mat-icon>close</mat-icon>
	</button>
</div>
<div mat-dialog-content>
	@if (attachments.length > 0 || isLoading) {
		<div>
			@if (isLoading) {
				<div class="flex flex-row justify-center">
					<mat-spinner
						color="primary"
						[diameter]="40" />
				</div>
			}
			<div>
				@for (attachment of attachments; track attachment) {
					<button
						mat-menu-item
						[matMenuTriggerFor]="menu">
						<div class="flex flex-row items-center justify-start gap-x-2">
							<img
								[ngSrc]="fileService.getExtensionIcon(attachment.extension)"
								alt="extension logo"
								height="32"
								width="32" />
							<span>{{ attachment.label }}</span>
						</div>
						<mat-menu #menu="matMenu">
							<button
								mat-menu-item
								[disabled]="attachment.extension !== 'pdf'"
								(click)="view(attachment)">
								<mat-icon>visibility</mat-icon>
								{{ "core.view" | translate }}
							</button>
							<button
								mat-menu-item
								(click)="downloadAttachment(attachment)">
								<mat-icon>download</mat-icon>
								{{ "core.download" | translate }}
							</button>
							<button
								mat-menu-item
								(click)="shareAttachment(attachment)"
								[disabled]="!attachment.enable_sharing">
								<mat-icon>share</mat-icon>
								{{ "core.share" | translate }}
							</button>
						</mat-menu>
					</button>
				}
			</div>
		</div>
	} @else {
		<div class="flex flex-col items-center justify-center">
			<img
				src="../../../../../assets/ng_not-found_robot.png"
				alt="not_found"
				class="w-[120px]" />
			<div class="m-4">{{ "protocol.attachments.empty.label" | translate }}</div>
		</div>
	}
</div>
